<script setup>
defineProps({
    manufacturer: { type: Object, required: true },
    zebraLogoUrl: { type: String, default: '' },
});

defineEmits(['click']);
</script>

<template>
  <div class="manufactor" @click="$emit('click')">
    <div class="manufactor__header">
      <div>
        <h2>{{ manufacturer.title }}</h2>
        <ul v-if="manufacturer.bus_sizes.length" class="manufactor__sizes">
          <li
            v-for="s in manufacturer.bus_sizes"
            :key="s"
            :class="`bus-size bus-size--${s}`"
          ></li>
        </ul>
      </div>
      <img v-if="manufacturer.zebra_stamp" class="manufactor__header__zebra" :src="zebraLogoUrl" />
    </div>
    <img
      v-if="manufacturer.logo"
      class="manufactor__logo"
      :src="manufacturer.logo"
      :style="manufacturer.logo_width ? `width:${manufacturer.logo_width}% !important` : ''"
    />
  </div>
</template>
